import { Component, OnInit, Inject, AfterViewInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from '@angular/common';

import { MessageService } from '../../services/message.service';
import { OpenEdgeService } from '../../services/open-edge.service'

import { InvoiceModel } from '../../models/invoice.model';

@Component({
	selector: 'heartland-form',
	templateUrl: './heartland-form.component.html',
	styles: []
})

export class HeartlandFormComponent implements OnInit, AfterViewInit {

	@Input('orderKey') orderKey: string;
	@Input('profile') profile: any;
	@Input('activeInvoice') activeInvoice: InvoiceModel;
	@Output() closer = new EventEmitter();
	public hps: any;
	public paymentProcessing: boolean = false;

	constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef, private _openEdgeService: OpenEdgeService, private _messageService: MessageService) { }

	ngOnInit(): void {
	}

	ngAfterViewInit() {
		const api = this.document.createElement('script');
		api.type = 'text/javascript';
		api.src = environment.globalPayApiScriptUrl;
		this.elementRef.nativeElement.appendChild(api);

		var publicKey = this.parsePublicKey();
		const s = this.document.createElement('script');
		s.type = 'text/javascript';
		s.text = 
		'function setupGlobalPay() {' +
		'GlobalPayments.configure({publicApiKey: "' + publicKey + '"});' +
		'var cardForm = GlobalPayments.creditCard.form("#open-edge-credit-card");' +
		'cardForm.on("token-success", (resp) => {' +
		'const paytoken = document.getElementById("paytoken");' +
		'const token = document.createElement("input");' +
		'token.type = "hidden";' +
		'token.name = "payment_token";' +
		'token.value = resp.paymentReference;' +
		'paytoken.value = resp.paymentReference;' +
		'paytoken.click();' +
		'const form = document.getElementById("payment-form");' +
		'form.appendChild(token);' +
		'form.submit(); });' +
		'cardForm.on("token-error", (resp) => { console.log("Get Heartland transaction token failed.", resp); }); ' +
		'}' +
		'setTimeout(setupGlobalPay, 150);'
		;
		this.elementRef.nativeElement.appendChild(s);
	}

	public getHeartlandToken(token: string) {
		if(!this.paymentProcessing && this.orderKey && this.orderKey.trim() != '') {
			this.paymentProcessing = true;
			this._openEdgeService.processOETransaction(token, this.orderKey, this.activeInvoice).subscribe((response: any) => {
				this.paymentProcessing = false;
				this.close(response);
			}, (error: any) => {
				this.paymentProcessing = false;
				this._messageService.showAppError('Error!', error);
				this.close(null);
			});
		}
		else {
			this._messageService.showAppError('Oops!', 'Payment processing cannot continue.');
			this.close(null);
		}
	}

	private parsePublicKey() {
		var publicKey: string;

		var foundIndex = this.profile?.params?.findIndex((f: any) => { return f.name == 'PublicApiKey'; });
		if(foundIndex >= 0) {
			publicKey = this.profile.params[foundIndex].value;
		}
		return publicKey;
	}

	private close(invoiceModel: any) {
		this.closer.emit({ invoiceModel: invoiceModel });
	}
}
